import { ACTION_TYPES } from './feedbacks-actions';
import {
    getValidationErrorTranslationKeys,
    isValidFeedback,
    togglePositive
} from './leave-feedback-helper';
import {
    MAX_RATING_VALUE,
    MIN_RATING_VALUE,
    RATING_NAMES,
    UNSET_RATING_VALUE
} from './constants';

export const initialState = {
    feedbacks: {},
    submittables: []
};

const updateValidationError = state => {
    Object.values(state.feedbacks).forEach(feedback => {
        feedback.errorMessageTranslationKeys = getValidationErrorTranslationKeys(
            feedback
        );
    });
};

const updateSubmittables = state => {
    state.submittables = Object.values(state.feedbacks)
        .filter(feedback => isValidFeedback(feedback))
        .map(validFeedback => {
            const feedback = { ...validFeedback };
            delete feedback.errorMessageTranslationKeys;
            return feedback;
        });
};

const isAllRatings = (feedback, rating) =>
    Object.values(feedback.ratings).every(value => value === rating);

const setAllRatings = (feedback, rating) =>
    Object.keys(feedback.ratings).forEach(
        key => (feedback.ratings[key] = rating)
    );

const resetItemNotReceivedIfNeeded = feedback => {
    if (feedback.ratings[RATING_NAMES.SHIPPING_TIME] !== MIN_RATING_VALUE) {
        feedback.inr = false;
    }
};

export const feedbacksReducer = (state, action) => {
    switch (action.type) {
        case ACTION_TYPES.SET_FEEDBACKS: {
            const newState = { ...state, feedbacks: { ...action.payload } };
            updateSubmittables(newState);
            updateValidationError(newState);
            return newState;
        }
        case ACTION_TYPES.TOGGLE_IS_POSITIVE: {
            const { transactionId, isPositive } = action.payload;
            const oldFeedback = state.feedbacks[transactionId];
            const newFeedback = {
                ...oldFeedback,
                isPositive: togglePositive(oldFeedback.isPositive, isPositive)
            };

            const shouldSetAllRatings =
                oldFeedback.isPositive === null ||
                isAllRatings(newFeedback, UNSET_RATING_VALUE) ||
                isAllRatings(newFeedback, MAX_RATING_VALUE);
            if (shouldSetAllRatings) {
                setAllRatings(
                    newFeedback,
                    newFeedback.isPositive
                        ? MAX_RATING_VALUE
                        : UNSET_RATING_VALUE
                );
            }

            const newState = { ...state };
            resetItemNotReceivedIfNeeded(newFeedback);
            newState.feedbacks[transactionId] = newFeedback;
            updateSubmittables(newState);
            updateValidationError(newState);
            return newState;
        }
        case ACTION_TYPES.SET_RATING: {
            const { transactionId, ratingName, rating } = action.payload;
            const oldFeedback = state.feedbacks[transactionId];
            const newRatings = {
                ...oldFeedback.ratings,
                [ratingName]: rating
            };
            const newFeedback = {
                ...oldFeedback,
                ratings: newRatings
            };
            const newState = { ...state };
            resetItemNotReceivedIfNeeded(newFeedback);
            newState.feedbacks[transactionId] = newFeedback;
            updateSubmittables(newState);
            updateValidationError(newState);
            return newState;
        }
        case ACTION_TYPES.SET_COMMENT: {
            const { transactionId, comment } = action.payload;
            const newFeedback = {
                ...state.feedbacks[transactionId],
                comment
            };
            const newState = { ...state };
            resetItemNotReceivedIfNeeded(newFeedback);
            newState.feedbacks[transactionId] = newFeedback;
            updateSubmittables(newState);
            updateValidationError(newState);
            return newState;
        }
        case ACTION_TYPES.SET_IS_ITEM_NOT_RECEIVED: {
            const { transactionId, isItemNotReceived } = action.payload;
            const newFeedback = {
                ...state.feedbacks[transactionId],
                inr: isItemNotReceived
            };
            const newState = { ...state };
            newState.feedbacks[transactionId] = newFeedback;
            updateSubmittables(newState);
            updateValidationError(newState);
            return newState;
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
};
